import { render } from "./jobPreview.vue?vue&type=template&id=08155c43&scoped=true&ts=true&lang=pug"
import script from "./jobPreview.vue?vue&type=script&lang=ts"
export * from "./jobPreview.vue?vue&type=script&lang=ts"

import "./jobPreview.vue?vue&type=style&index=0&id=08155c43&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08155c43"]])

export default __exports__